/**
 * Wires the client's module_disabled notifier to the app (handoff §3).
 *
 * The seatbelt for stale sessions: a route guard hides disabled modules, but if
 * one gets toggled off mid-session, the next API call to it returns 403
 * module_disabled. When that happens we refetch /auth/me (so the sidebar drops
 * the module), toast the server's message, and send the user home.
 *
 * Renders nothing — it exists only for the subscription. Mounted once, inside
 * the auth + toast + router providers so all three are in scope.
 */
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { onModuleDisabled } from "@shared/api";
import { useAuth } from "@features/auth/AuthContext";
import { useToast } from "@shared/ui/Toast/ToastProvider";

export const ModuleDisabledListener: React.FC = () => {
  const { refreshUser } = useAuth();
  const { showToast } = useToast();
  const navigate = useNavigate();

  useEffect(() => {
    onModuleDisabled((_module, message) => {
      // Refresh module state so the sidebar re-renders without the module.
      void refreshUser();
      showToast(message, "warning");
      navigate("/", { replace: true });
    });
    return () => onModuleDisabled(null);
  }, [refreshUser, showToast, navigate]);

  return null;
};
